import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';

import { ApiService } from '../../app/services/api.service';
import { GridPage } from '../grid/grid';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  providers: [ApiService]
})


export class LoginPage {
  private email_address: string = "";
  private password: string = "";
  private messageError: string = "";
  private messageErrorSNS: string = "";
  private sns_id: number = 0;
  private visitor_id: any = 0;
  private client_cd: string = "";
  private store_id: any = 0;
  loading: any;

  constructor(public navCtrl: NavController,
            private _apiService: ApiService,
            private loadingCtrl: LoadingController) {


    // start login qrcode
    this.visitor_id    = localStorage.getItem("visitor_id"); 
    this.client_cd     = localStorage.getItem("client_cd");
    this.store_id      = localStorage.getItem("store_id");
  }


  public login() {
    if (this.password == "") {
      this.messageError = "パスワードが入力されていません";
      return false;
    }
    this.loading = this.loadingCtrl.create();
    this.loading.present();
    this._apiService.getVisitor(this.password).subscribe(
      (result) => {
        console.log("result: " + result);
        //console.log("result status: " + result.status);
        if ( result.status == 1000 ) {
            localStorage.setItem("visitor_id", result.visitor["visitor_id"]);
            window.document.location.href = location.protocol + '//' + location.host + location.pathname;

        } else {
          this.messageError =  "ユーザー名またはパスワードが間違っています.";
          console.log(result);
          this.loading.dismiss();
        }

    },
    error => {
        console.log('[api] Submit process errror: ' + error);
        this.messageError =  "ユーザー名またはパスワードが間違っています.";
        this.loading.dismiss();
        //window.location.reload();
    });

  }


}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts